export default "__VITE_ASSET__002a37ab__"